import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { ProductReveal } from './components/ProductReveal';
import { TransformationSection } from './components/TransformationSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="min-h-screen bg-navy-dark text-white font-sans selection:bg-gold selection:text-navy-dark" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <SolutionSection data-id="element-3" />
      <ProductReveal data-id="element-4" />
      <TransformationSection data-id="element-5" />
      <BonusesSection data-id="element-6" />
      <PricingSection data-id="element-7" />
      <TestimonialsSection data-id="element-8" />
      <Footer data-id="element-9" />
      <PurchasePopup data-id="element-10" />

      {/* Global styles for animations that are hard to do with just tailwind classes */}
      <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes shine {
          0% { left: -100%; }
          20% { left: 200%; }
          100% { left: 200%; }
        }
      `
    }} data-id="element-11" />
    </div>;
}